import { render } from "./VehicleImage.vue?vue&type=template&id=2cfcd384"
import script from "./VehicleImage.vue?vue&type=script&lang=js"
export * from "./VehicleImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__